<template>
  <div id="tagList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" type="text" v-model="searchData.name" placeholder="标签">
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="departmentList" :needReturn="'description'" :placeholder="'科室'" :matchValue="'description'" :showValue="'{{description}}'" v-model="searchData.department">
              </allSelect>
            </abbr>
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="fieldsList" :needReturn="'id'" :placeholder="'领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.fieldId">
              </allSelect>
            </abbr>
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="indicationsList" :needReturn="'id'" :placeholder="'适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.indicationId">
              </allSelect>
            </abbr>
          </p>
          <button @click="getTagList(1)" class="redButtonTwo">搜索</button>
        </div>
        <div style="width: auto">
          <!-- <button class="redButtonTwo" @click="ImportNewTag">标签导入</button> -->
          <button class="redButtonTwo" @click="addNewTag">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div style="overflow:auto; width: 100%;">
        <table cellspacing="0" class="allTable" :style="tagList.length > 0 ? 'width: 140%;' : 'width: 100%;'">
          <thead>
          <tr>
            <th class="t_c">标签名</th>
            <th class="t_c">科室</th>
            <th class="t_c">领域</th>
            <th class="t_c">适应症</th>
            <th class="t_c">父标签</th>
            <th class="t_c">创建人</th>
            <th class="t_c">创建日期</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="tagList.length > 0">
              <tr :key="index" v-for="(item, index) in tagList">
                <td width="10%" class="t_c NoWrap" :title="item.name">{{item.name}}</td>
                <td width="10%" class="t_c NoWrap" :title="item.department ? item.department.join(',') : ''" style="max-width: 180px;">
                  {{item.department ? item.department.join(',') : ''}}
                </td>
                <td width="15%" class="t_c NoWrap" :title="item.fieldNames" style="max-width: 180px;">{{item.fieldNames}}</td>
                <td width="15%" class="t_c NoWrap" :title="item.indicationNames" style="max-width: 180px;">{{item.indicationNames}}</td>
                <td width="10%" class="t_c NoWrap" :title="item.parentName">{{item.parentName}}</td>
                <td width="10%" class="t_c NoWrap" :title="item.createName">{{item.createName}}</td>
                <td width="15%" class="t_c NoWrap" :title="item.createTime">{{item.createTime}}</td>
                <td width="15%" class="t_c">
                  <div class="icon more iconfont icongengduo moreOperations">
                    <ul>
                      <li @click="editTag(item)">编辑</li>
                      <li @click="deleteTag(item)">删除</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="8">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getTagList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!-- 新建标签 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="height:250px;width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>标签名</span>
            <input maxlength="50" v-model="modelData.name" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>是否为父标签</span>
            <input v-model="modelData.isParent" :value="true" type="radio" class="allRadio" id="radio1" name="radio1"/>
              <label for="radio1"></label><abbr>是</abbr>
              <input v-model="modelData.isParent" :value="false" type="radio" class="allRadio" id="radio2" name="radio2"/>
              <label for="radio2"></label><abbr>否</abbr>
          </li>
          <template v-if="modelData.isParent">
            <li>
              <span style="font-size:16px"><i class="colorRed m_r_5">*</i>产品组</span>
              <span style="width: calc(100% - 110px); margin-left: -30px;">
                <allSelect v-if="isadmin" :width="302" :chooseData="allProduct" :needReturn="'id'" :placeholder="'请选择产品组'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.productId">
                </allSelect>
                <allSelect v-else :width="302" :chooseData="productList" :needReturn="'id'" :placeholder="'请选择产品组'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.productId">
                </allSelect>
              </span>
            </li>
            <!-- <li>
              <span style="font-size:16px"><i class="colorRed m_r_5">*</i>科室</span>
              <span style="width: calc(100% - 110px); margin-left: -30px;">
                <allSelect :multiple="true" :width="302" :chooseData="departmentListNew" :needReturn="'description'" :placeholder="'科室'" :matchValue="'description'" :showValue="'{{description}}'" v-model="modelData.department">
                </allSelect>
              </span>
            </li>
            <li>
              <span style="font-size:16px"><i class="colorRed m_r_5">*</i>领域</span>
              <span style="width: calc(100% - 110px); margin-left: -30px;">
                <allSelect :multiple="true" :width="302" v-on:on-change="changeField" :chooseData="fieldsListNew" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.fieldIds">
                </allSelect>
              </span>
            </li>
            <li>
              <span style="font-size:16px"><i class="colorRed m_r_5">*</i>适应症</span>
              <span style="width: calc(100% - 110px); margin-left: -30px;">
                <allSelect :multiple="true" :width="302" :chooseData="indicationsListNew" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.indicationIds">
                </allSelect>
              </span>
            </li> -->
          </template>
          <template v-else>
            <li>
              <span style="font-size:16px"><i class="colorRed m_r_5">*</i>父标签</span>
              <span style="width: calc(100% - 110px); margin-left: -30px;">
                <allSelect :width="302" :chooseData="parentTagList" :needReturn="'id'" :placeholder="'请选择父标签'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.parentId">
                </allSelect>
              </span>
            </li>
          </template>
        </ul>
      </div>
    </model>
        <!-- 导入标签 -->
    <model v-if="showModelImport" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelTagModel()" v-on:on-confirm="confirModelImport()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>请上传文件</span>
            <input @change="uploadTagimportfile($event)" type="file" id="file" multiple>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>
<script>
export default {
  name: 'tagList',
  data () {
    return {
      searchData: {
        // status: 2, // 和全部内容页面传的一样
        name: '',
        department: '',
        fieldId: '',
        indicationId: '',
        userID: '',
        type: 1, // Defualt=1,// 普通标签; Department=2,//科室; Indication=3,//适应症; Field=4,//领域; 0=所有
      },
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      isOnlyParent: false, // 只显示父级标签
      isadmin: JSON.parse(window.localStorage.getItem('isAdmin')), // 管理员
      //fieldsListNew: [],
      fieldsList: [], // 领域
      //indicationsListNew: [],
      indicationsList: [], // 适应症
      //departmentListNew: [],
      departmentList: [], // 科室
      page: 1,
      pageSize: 10,
      totalPage: 0,
      totalCount: 0,
      tagList: [],
      showModel: false,
      showModelImport:false,
      FilePD: 'False',
      modelTitle: '',
      modelData: {
        id: 0,
        name: '',
        isParent: true, // 是否为父级标签
        //department: '',
        //fieldIds: '',
        //indicationIds: '',
        parentId: 0, // 父级标签id
        productId: 0 // 产品组
      },
      parentTagList: [], // 父标签下拉列表
      allProduct: [], // 所有产品组
      productList: JSON.parse(window.localStorage.getItem('productList')) || [], // 产品组
    }
  },
  created () {
    // 获取标签列表
    this.getTagList(1)
    // 获取父标签
    this.getParentTagList()
    // 获取科室
    this.getDepartmentList()
    // 获取领域
    this.getFieldsList()
    // 获取适应症
    this.getIndicationsList()
    // 获取产品组
    this.getAllProDuct()
  },
  mounted () {

  },
  methods: {
    // 获取标签列表
    getTagList (page) {
      this.page = page
      let data = JSON.parse(JSON.stringify(this.searchData))
      data.department = data.department.replace('全部', '')
      data.userID = this.userInfo.id
      data.isOnlyParent = false
      data.isadmin = this.isadmin
      console.log(data, 'data')
      let params = {
        pageIndex: page,
        pageSize: this.pageSize
      }
      let url = this.$commonJs.returnQuery('/api/Article/QueryArticleTag', data)
      this.$axiox.post(url, params).then(res => {
        console.log(res, '获取标签列表')
        if (res.data && res.data.length > 0) {
          this.tagList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.tagList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },
    // 获取父标签
    getParentTagList () {
      let data = {
        status: 2, // 和全部内容页面传的一样
        name: '',
        department: '',
        fieldId: '',
        indicationId: '',
        userID: this.userInfo.id,
        isOnlyParent: true,
        isadmin: this.isadmin,
        type: 1
      }
      console.log(data, 'data')
      let params = {
        pageIndex: 1,
        pageSize: 9999
      }
      let url = this.$commonJs.returnQuery('/api/Article/QueryArticleTag', data)
      this.$axiox.post(url, params).then(res => {
        console.log(res, '获取标签列表')
        if (res.data && res.data.length > 0) {
          this.parentTagList = res.data
        } else {
          this.parentTagList = []
        }
      })
    },
    uploadTagimportfile(e){
      var file = e.target.files[0]
      this.TagUpload(file)
      this.FilePD='True'
      //e.target.value = '' // 防止第二次上传相同的文件不执行 //document.getElementById('file').value = ''
    },
    async TagUpload (e) {
      let fileImg = e
      await this.$commonJs.uploadFile2(fileImg, '/api/RotationChart/AddTagFile')
    },
    // 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        //this.fieldsListNew = JSON.parse(JSON.stringify(res))
        this.fieldsList = [
          {
            id: 0,
            name: '全部',
          },
          ...res
        ]
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      console.log(ids, 'ids-------99999999999')
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        console.log(res, 'getIndicationsList')
        // if (this.modelData.fieldIds) {
        //   this.indicationsListNew = JSON.parse(JSON.stringify(res))
        // } else {
        //   this.indicationsListNew = []
        // }
        this.indicationsList = [
          {
            id: 0,
            fieldId: '',
            name: '全部',
          },
          ...res
        ]
      })
    },
    // 获取科室
    getDepartmentList () {
      this.$axiox.get('/api/Dict/GetHosDepts').then(res => {
        //this.departmentListNew = res
        this.departmentList = [
          {
            id: 0,
            description: '全部',
          },
          ...res
        ]
      })
    },
    // 新建标签
    addNewTag () {
      this.modelTitle = '新建标签'
      this.showModel = true
    },
    ImportNewTag () {
      this.modelTitle = '导入标签'
      this.showModelImport = true
    },
    confirModel () {
      console.log(this.modelData, 'modelData')
      if (this.modelData.id == 0) {
        // 新建
        console.log(this.modelData, 'modelData')
        if (this.modelData.name && ((this.modelData.isParent && this.modelData.productId) || (!this.modelData.isParent && this.modelData.parentId))) {
          let params = {
            name: this.modelData.name,
            isParent: this.modelData.isParent,
            //fieldIds: this.modelData.fieldIds ? this.modelData.fieldIds.split(',').map(val => Number(val)) : [],
            //indicationIds: this.modelData.indicationIds ? this.modelData.indicationIds.split(',').map(val => Number(val)) : [],
            //department: this.modelData.department ? this.modelData.department.split(',') : [],
            parentId: this.modelData.parentId,
            productId: this.modelData.productId,
            type: 1
          }
          this.$axiox.post(`/api/Article/AddArticleTag`, params).then(res => {
            console.log(res, '添加标签')
            if (res) {
              // 获取标签列表
              this.getTagList(1)
              // 获取父标签
              this.getParentTagList()
              this.showModel = false
              this.modelData.id = 0
              this.modelData.name = ''
              this.modelData.isParent = true
              //this.modelData.fieldIds = ''
              //this.modelData.indicationIds = ''
              //this.modelData.department = ''
              this.modelData.parentId = 0
              this.modelData.productId = 0
            }
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
        }
      } else {
        // 编辑
        if (this.modelData.name && ((this.modelData.isParent && this.modelData.productId) || (!this.modelData.isParent && this.modelData.parentId))) {
          let params = {
            id: this.modelData.id,
            name: this.modelData.name,
            isParent: this.modelData.isParent,
            //fieldIds: this.modelData.fieldIds ? this.modelData.fieldIds.split(',').map(val => Number(val)) : [],
            //indicationIds: this.modelData.indicationIds ? this.modelData.indicationIds.split(',').map(val => Number(val)) : [],
            //department: this.modelData.department ? this.modelData.department.split(',') : [],
            parentId: this.modelData.parentId,
            productId: this.modelData.productId,
            type: 1
          }
          this.$axiox.put(`/api/Article/UpdateArticleTag`, params).then(res => {
            console.log(res, '修改标签')
            if (res) {
              // 获取标签列表
              this.getTagList(1)
              // 获取父标签
              this.getParentTagList()
              this.modelData.id = 0
              this.showModel = false
              this.modelData.name = ''
              this.modelData.isParent = true
              //this.modelData.fieldIds = ''
              //this.modelData.indicationIds = ''
              //this.modelData.department = ''
              this.modelData.parentId = 0
              this.modelData.productId = 0
            }
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
        }
      }
    },
    confirModelImport () {
      if(this.FilePD=='False'){
        this.$commonJs.alertTips({
            type: 'error',
            title: '失败！',
            content: '请上传附件！',
            stayTime: 5
          })
          return;
      }
     this.$axiox.get(`/api/Article/AddArticleTagImport`).then(res => {
      if(res=='Suc'){
        this.$commonJs.alertTips({
            type: 'success',
            title: '成功！',
            content: '导入成功！',
            stayTime: 5
          })
      }else{
        this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: res,
            stayTime: 5
          })
      }
      this.showModelImport = false
      this.getTagList(1)
      this.FilePD='False'
      })
    },
    cancelModel () {
      this.showModel = false
      this.modelData.id = 0
      this.modelData.name = ''
      //this.modelData.department = ''
      //this.modelData.fieldIds = ''
      //this.modelData.indicationIds = ''
      this.modelData.isParent = true
      this.modelData.productId = 0
    },
    cancelTagModel () {
      this.showModelImport = false
      this.getTagList(1)
    },
    // 编辑标签id
    editTag (item) {
      this.modelTitle = '编辑标签'
      this.modelData.id = item.id
      this.modelData.name = item.name
      //this.modelData.department = item.department.join(',')
      //this.modelData.fieldIds = item.fieldIds.join(',')
      //this.modelData.indicationIds = item.indicationIds.join(',')
      this.modelData.isParent = item.isParent
      this.modelData.parentId = item.parentId
      this.modelData.productId = item.productId
      this.showModel = true
    },
    changeField () {
      this.modelData.indicationIds = ''
    },
    deleteTag (item) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此标签？',
        successFun: msg => {
          this.$axiox.del('/api/Article/DeleteIndications?topicId=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            // 获取标签列表
            this.getTagList(1)
            // 获取父标签
            this.getParentTagList()
          })
        },
        errorFun: msg => {
        }
      })
    },
    // 获取产品组
    getAllProDuct () {
      this.$axiox.get('/api/product/query?pageIndex=1&pageSize=9999').then(p => {
        this.allProduct = p
      })
    },
  },
  watch: {
    "searchData.fieldId" (newData) {
      if (newData) {
        console.log(newData, 'searchData.fieldId')
        let ids = [newData]
        this.getIndicationsList(ids)
      } else {
        this.getIndicationsList([])
      }
    },
    // "modelData.fieldIds" (newData) {
    //   console.log(newData, 'modelData.fieldIds')
    //   if (newData) {
    //     let ids = (newData.split(',')).map(val => Number(val))
    //     console.log(ids, 'ids')
    //     this.getIndicationsList(ids)
    //   } else {
    //     //this.indicationsListNew = []
    //   }
    // },
    "modelData.isParent" (newData) {
      console.log(newData, 'modelData.isParent')
      if (newData) {
        this.modelData.parentId = 0
      } else {
        //this.modelData.department = ''
        //this.modelData.fieldIds = ''
        //this.modelData.indicationIds = ''
        this.modelData.productId = 0
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/tagManager/tagList.vue